"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ShippingKit = void 0;
const common_1 = require("../../common");
const models_1 = require("../../setup/models");
const enums_1 = require("../enums");
const index_1 = require("./index");
const packaging_set_model_1 = require("./packaging-set.model");
const shipping_kit_line_model_1 = require("./shipping-kit-line.model");
class ShippingKit extends common_1.MongoDocument {
}
exports.ShippingKit = ShippingKit;
//# sourceMappingURL=shipping-kit.model.js.map